import React from 'react'

/**
 * Eigenes Studio-Mark (keine Signalbalken / kein Fremd-Branding).
 */
export function BrandMark({ className = '', size = 28 }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden
    >
      <rect x="1.5" y="1.5" width="29" height="29" rx="8" stroke="currentColor" strokeWidth="1.5" opacity="0.35" />
      <path
        d="M8 22 L16 8 L24 22"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.5 16.5 H20.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  )
}

/**
 * Atmosphäre: radiale Ringe + Grid – klar anders als eine Ribbon-Wave.
 */
export default function StudioAura({ className = '', height = 220, animate = true }) {
  return (
    <div
      className={`pointer-events-none relative overflow-hidden ${className}`}
      style={height === '100%' || height === 'full' ? { height: '100%', width: '100%' } : { height }}
      aria-hidden
    >
      <div
        className="absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
          maskImage: 'radial-gradient(ellipse 70% 80% at 50% 60%, #000 20%, transparent 75%)',
          WebkitMaskImage: 'radial-gradient(ellipse 70% 80% at 50% 60%, #000 20%, transparent 75%)',
        }}
      />
      <div
        className={`absolute left-1/2 top-[42%] h-[140%] w-[140%] -translate-x-1/2 -translate-y-1/2 ${animate ? 'studio-aura-spin' : ''}`}
        style={{
          background:
            'conic-gradient(from 180deg, transparent 0deg, rgba(0,212,170,0.18) 60deg, transparent 120deg, rgba(0,180,200,0.12) 200deg, transparent 280deg)',
        }}
      />
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 400 220" preserveAspectRatio="xMidYMid slice">
        <defs>
          <radialGradient id="studioCore" cx="50%" cy="55%" r="45%">
            <stop offset="0%" stopColor="#00d4aa" stopOpacity="0.45" />
            <stop offset="55%" stopColor="#00d4aa" stopOpacity="0.08" />
            <stop offset="100%" stopColor="#00d4aa" stopOpacity="0" />
          </radialGradient>
        </defs>
        <ellipse cx="200" cy="130" rx="150" ry="70" fill="url(#studioCore)" />
        <circle cx="200" cy="120" r="54" fill="none" stroke="#00d4aa" strokeOpacity="0.35" strokeWidth="1.2" className={animate ? 'studio-ring' : ''} />
        <circle cx="200" cy="120" r="78" fill="none" stroke="#00d4aa" strokeOpacity="0.18" strokeWidth="1" className={animate ? 'studio-ring-slow' : ''} />
        <circle cx="200" cy="120" r="102" fill="none" stroke="#00a8c8" strokeOpacity="0.12" strokeWidth="1" />
      </svg>
      <style>{`
        @keyframes studio-aura-spin {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to { transform: translate(-50%, -50%) rotate(360deg); }
        }
        .studio-aura-spin {
          animation: studio-aura-spin 28s linear infinite;
        }
        @keyframes studio-ring-pulse {
          0%, 100% { opacity: 0.35; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.03); }
        }
        .studio-ring {
          transform-origin: 200px 120px;
          animation: studio-ring-pulse 4.5s ease-in-out infinite;
        }
        .studio-ring-slow {
          transform-origin: 200px 120px;
          animation: studio-ring-pulse 7s ease-in-out infinite reverse;
        }
        @media (prefers-reduced-motion: reduce) {
          .studio-aura-spin, .studio-ring, .studio-ring-slow { animation: none; }
        }
      `}</style>
    </div>
  )
}
